import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Exam season and analysis fail",
  "description": "",
  "published": "2009-01-23T00:00:00.000Z",
  "redirect_from": ["/blog/exam-season-and-analysis-fail/swizec/14"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Exam season started on my faculty this week, probably started for the whole university but I am never too certain on these things, and I've been so busy working four hours a day and studying most of the rest of the time I didn't even manage to blog or anything. There were many ideas, but I just couldn't get to it.`}</p>
    <p>{`Most surprising of all was that I felt the pull to study, same kind of pull I usually feel about working on an interesting project and I have to say the last time I remember feeling like this about studying was back when I had to pass matura to graduate high school. Cool, seems like I've started taking this university thing seriously right?`}</p>
    <p>{`Well ... kind of. I failed the analysis exam yesterday after having studied for it an unprecedented 12(!) hours over four days. This is unprecedented on several levels, the most days studying before an exam, the most hours studied in a day and I have to say I've never been so well prepared for any exam on college to date (except programming but that doesn't count because it's my forte). Cool stuff. So I failed, big deal, I had a decently high score compared to my previous track record for this class.`}</p>
    <p>{`Next exam is in about a fortnight and then another one three days after that. Sufficient time, now let's hope the pull remains and I utlise it properly. Let's pass these two, woot!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      